import { createListenerMiddleware } from '@reduxjs/toolkit';
import { initIntentConversation } from 'actions/workflows-v2/workflowsV2';
import { reloadTranslatedWidgetConfig } from 'actions/workflows/workflows';
import type { AppDispatch } from 'store';

export const widgetConfigReloadListenerMiddleware = createListenerMiddleware();

widgetConfigReloadListenerMiddleware.startListening({
  actionCreator: initIntentConversation.fulfilled,
  effect: (action, listenerApi) => {
    const dispatch = listenerApi.dispatch as AppDispatch;
    /**
     * This effect is responsible for reloading the translated widget
     * configuration when the initIntentConversation action is fulfilled.
     */
    dispatch(reloadTranslatedWidgetConfig());
  },
});
